<template>
    <div class="examen-medico-form">
        <div class="form-header">
            <h3 class="form-title">
                <i class="fa-solid fa-user-doctor text-primary"></i>
                Exámenes Médicos
            </h3>
            <b-button variant="primary" size="sm" @click="collapsed = !collapsed" class="toggle-btn">
                <i :class="collapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
            </b-button>
        </div>

        <b-collapse v-model="collapsed" class="mt-3">
            <b-card class="shadow-sm border-0 bg-dark">
                <b-form @submit.prevent="registrarExamenMedico" novalidate>
                    <!-- Información del conductor -->
                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Tipo de documento del conductor" label-for="tipo-documento-medico"
                                label-class="form-label-custom">
                                <v-select id="tipo-documento-medico" v-model="form.tipoIdentificacion"
                                    :options="tipoIdentificaciones" :reduce="option => option.codigo"
                                    :get-option-label="option => option.descripcion"
                                    placeholder="-- Selecciona tipo documento --" class="v-select-custom">
                                    <template #search="{ attributes, events }">
                                        <input class="vs__search" :required="!form.tipoIdentificacion"
                                            v-bind="attributes" v-on="events" />
                                    </template>
                                    <template #no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se encontraron resultados para
                                            <em class="text-danger">{{ search }}</em>
                                        </template>
                                        <em v-else class="text-muted">No hay datos para mostrar</em>
                                    </template>
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Número de documento" label-for="numero-documento-medico"
                                label-class="form-label-custom" :invalidFeedback="mensajesError.numeroIdentificacion">
                                <b-form-input id="numero-documento-medico" v-model="form.numeroIdentificacion"
                                    type="number" placeholder="Ej: 123456789" min="0" max="12" required :state="estadosCampos.numeroIdentificacion" @input="validarNumero(12, 'numeroIdentificacion')" />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Fecha y hora del examen -->
                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Fecha de examen" label-for="fecha-examen-medico"
                                label-class="form-label-custom">
                                <b-form-input id="fecha-examen-medico" v-model="form.fechaExamen" type="date"
                                    required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Hora de examen" label-for="hora-examen-medico"
                                label-class="form-label-custom">
                                <b-form-input id="hora-examen-medico" v-model="form.horaExamen" type="time" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Resultado -->
                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Resultado" label-for="resultado" label-class="form-label-custom">
                                <v-select id="tipo-documento" v-model="form.resultado" :options="tipoResultado"
                                    placeholder="-- Resultado de la prueba --" class="v-select-custom">
                                    <template #search="{ attributes, events }">
                                        <input class="vs__search" :required="!form.resultado" v-bind="attributes"
                                            v-on="events" />
                                    </template>
                                    <template #no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se encontraron resultados para
                                            <em class="text-danger">{{ search }}</em>
                                        </template>
                                        <em v-else class="text-muted">No hay datos para mostrar</em>
                                    </template>
                                </v-select>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Botón de envío -->
                    <div class="d-flex justify-content-end pt-3">
                        <b-button type="submit" variant="primary" size="lg" :disabled="loading" class="btn-submit">
                            <b-spinner v-if="loading" small class="mr-2"></b-spinner>
                            <i v-else class="fa-solid fa-floppy-disk mr-2"></i>
                            {{ loading ? 'Guardando...' : 'Guardar Examen Médico' }}
                        </b-button>
                    </div>
                </b-form>
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
import { validarCampoTexto } from '../../../../../assets/js/validations/validarCampoTexto';
export default {
    name: 'FormularioExamenMedico',
    props: {
        tipoIdentificaciones: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            collapsed: true,
            loading: false,
            form: {
                tipoIdentificacion: null,
                numeroIdentificacion: '',
                fechaExamen: '',
                horaExamen: '',
                resultado: '',
            },
            tipoResultado: [
                'Apto',
                'No Apto'
            ],
            estadosCampos: {
                numeroIdentificacion: null,
            },
            mensajesError: {
                numeroIdentificacion: '',
            }
        }
    },
    methods: {
        formatFechaDDMMYYYY(fechaISO) {
            if (!fechaISO) return '';
            const [yyyy, mm, dd] = fechaISO.split('-');
            return `${dd}/${mm}/${yyyy}`;
        },

        async registrarExamenMedico() {
            this.loading = true;

            const data = {
                tipoIdentificacion: this.form.tipoIdentificacion,
                numeroIdentificacion: this.form.numeroIdentificacion,
                fechaExamen: this.formatFechaDDMMYYYY(this.form.fechaExamen), // Aquí formateamos la fecha
                horaExamen: this.form.horaExamen,
                resultado: this.form.resultado,
            };

            this.$emit('submit', data);
            this.loading = false;
        },

        resetForm() {
            this.form = {
                tipoIdentificacion: null,
                numeroIdentificacion: '',
                fechaExamen: '',
                horaExamen: '',
                resultado: '',
            };
        },
        validarNumero(max, campo) {
            validarCampoTexto({
                objeto: this.form,
                campo: campo,
                max: max,
                soloNumeros: true,
                estados: this.estadosCampos,
                mensajes: this.mensajesError
            })
        }
    }
}
</script>

<style scoped>
.examen-medico-form {
    margin-bottom: 2rem;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-radius: 0.5rem;
    border-left: 4px solid #007bff;
    box-shadow: 0 2px 6px rgba(75, 72, 72, 0.37);
}

.form-title {
    margin: 0;
    font-weight: 600;
    font-size: 1.25rem;
}

.toggle-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-label-custom {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.v-select-custom {
    border-radius: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle {
    border: 2px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-submit {
    padding: 0.75rem 2rem;
    border-radius: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.card {
    border-radius: 0.75rem;
    border: none;
}
</style>
